import SendIcon from "@mui/icons-material/Send";
import { useClientDetails } from "../../../context/clientDetailsContext";
import { Box, Button } from "@mui/material";

const SendInviteEmailButton = () => {
  const { sendInviteEmail } = useClientDetails();

  return (
    <Box>
      <Button
        endIcon={<SendIcon />}
        variant="contained"
        onClick={() => sendInviteEmail.send()}
        loading={sendInviteEmail.loading}
        loadingPosition="end"
      >
        Send Invite Email
      </Button>
    </Box>
  );
};

export default SendInviteEmailButton;
